var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLiveEvent = function SvgLiveEvent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 34,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 0C8.116 0 .5 7.616.5 17s7.616 17 17 17 17-7.616 17-17-7.616-17-17-17Zm4.522 19.941-2.176 1.258-2.176 1.258c-2.805 1.615-5.1.289-5.1-2.941v-5.032c0-3.247 2.295-4.556 5.1-2.941l2.176 1.258 2.176 1.258c2.805 1.615 2.805 4.267 0 5.882Z",
    fill: "#8E6F00"
  })));
};
export default SvgLiveEvent;